import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const BulkToneToggleContainer = styled.div<{ $isVisible: boolean }>`
  width: 100%;
  height: ${({ $isVisible }) => ($isVisible ? '33px' : '0px')};
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 2px;
  background-color: ${COLORS.primaryLight};

  transition:
    height 0.2s linear,
    background-color 0.2s linear;
  cursor: pointer;

  .bulk-tone-text {
    padding: 8px 16px;
    transition: color 0.2s linear;
  }

  &:hover {
    .bulk-tone-text {
      color: ${COLORS.primaryDark};
    }
    background-color: ${COLORS.primarySemiLight};
  }

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: ${({ $isVisible }) => ($isVisible ? '40px' : '0px')};
    .bulk-tone-text {
      padding: 12px 16px;
    }
  }
`

export const BulkToneContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`
